import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { CoaParameter, CoaRequest, ProductCoasParameter } from 'src/app/models/coa-parameter';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { CoasParameterService } from 'src/app/services/coas-parameter.service';
import { CoasService } from 'src/app/services/coas.service';
import { CompanyService } from 'src/app/services/company.service';
import { ProductCpService } from 'src/app/services/product-cp.service';
import { ProductService } from 'src/app/services/product.service';
import { VendorService } from 'src/app/services/vendor.service';

interface CoaVM {
  parameter: CoaParameter;
  value: number;
  comment: string;
}

@Component({
  selector: 'app-create-coa',
  templateUrl: './create-coa.component.html',
  styleUrls: ['./create-coa.component.scss']
})
export class CreateCoaComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  products: ProductResponse[] = [];
  providers: VendorResponse[] = [];
  coasParameter: CoaParameter[] = [];
  listParams: CoaVM[] = [];
  coaData = {
    date: new Date()
  }
  inputs = {
    provider: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        measurement: null
      }
    },
    parameter: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
      }
    }
  }
  loading = false;
  filterProviders: VendorResponse[] = [];
  filterProducts: ProductResponse[] = [];
  filterCoasParameter: CoaParameter[] = [];
  productCoasParameters: ProductCoasParameter[] = [];
  currentProvider: VendorResponse;
  currentProduct: ProductResponse;
  timeout = null;

  checkListOwnProducts = false;
  productsCpVendor = null;

  constructor(
    private vendorService: VendorService,
    private productService: ProductService,
    private productCpService: ProductCpService,
    private companyService: CompanyService,
    private coaService: CoasService,
    private coasParameterService: CoasParameterService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getCheckListOwnProducts();
    this.getProviders("");
    this.getParameters("");
  }


  getCheckListOwnProducts() {
    this.companyService.checkCompanyConfigListOwnProducts().subscribe({
      next: (response: ResponseObject) => {
        this.checkListOwnProducts = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }


  getProviders(clue) {
    this.vendorService.getProvidesByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.filterProviders = this.providers;
        if (this.filterProviders.length == 0) {
          this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
        } else if (this.filterProviders.length == 1) {
          this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        const allProducts = response.data;

        if (this.checkListOwnProducts && this.productsCpVendor?.length > 0) {
          const allowedIds = this.productsCpVendor.map(p => p.productId);
          this.products = allProducts.filter(prod => allowedIds.includes(prod.id));
        } else {
          this.products = allProducts;
        }

        this.filterProducts = [...this.products];

        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastrService.error(error.error.message);
      }
    });
  }


  getParameters(clue) {
    this.coasParameterService.getCoasParameters().subscribe({
      next: (response: ResponseObject) => {
        this.coasParameter = response.data

        this.filterCoasParameter = this.coasParameter;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.parameter, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.parameter, this.filterCoasParameter[0].parameter, true, null, 'fa-circle-check', this.filterCoasParameter[0]);
        } else {
          this.changeInput(this.inputs.parameter, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.parameter, null, false, null, 'fa-xmark', null);
        this.toastrService.error(error.error.message);
      }
    });
  }

  getProductParameter() {
    if (!this.inputs.product.data || !this.inputs.provider.data) {
      return;
    }
    this.loading = true;
    this.coasParameterService.getAssignments(this.inputs.provider.data.id, this.inputs.product.data.id).subscribe({
      next: (response: ResponseObject) => {
        this.productCoasParameters = response.data ?? [];
        this.productCoasParameters.forEach(element => {
          this.listParams.push({ parameter: element.parameterData, value: null, comment: null });
        });
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
        this.loading = false;
      }
    });
  }

  createCoa() {
    if (!this.coaData.date || this.listParams.length == 0 || this.currentProvider == null) {
      return;
    }
    let data: CoaRequest = {
      productId: this.currentProduct.id,
      recipientProvider: this.currentProvider.id,
      date: this.coaData.date,
      details: this.listParams.map((p) => {
        return {
          coasParameterId: p.parameter.id,
          value: p.value,
          comment: p.comment
        }
      })
    }

    this.coaService.createCoa(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("COA creado correctamente.", "Exito");
        this.closed.emit(true);
        this.showModal = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message, "Error");
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProvider(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.provider.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProviders(inputValue);
    }, 500);
  }

  checkProvider(vendor: VendorResponse) {
    this.inputs.provider.class = "fa-circle-check";
    this.inputs.provider.verified = true;
    this.inputs.provider.data = vendor;
    this.inputs.provider.value = vendor.name;
    this.currentProvider = vendor;

    if (this.checkListOwnProducts) {
      this.getProductsCpByVendor(vendor.id);
    } else {
      this.getProducts("");
    }

    this.getParamSpProviderProduct();
  }

  getProductsCpByVendor(providerId: number) {
    this.productCpService.getProducsCPByVendorId(providerId).subscribe({
      next: (response: ResponseObject) => {
        this.productsCpVendor = response.data || [];

        if (this.productsCpVendor.length > 0) {
          this.productService.getProducts('').subscribe({
            next: (resp: ResponseObject) => {
              const allProducts: ProductResponse[] = resp.data;
              const allowedIds = this.productsCpVendor.map(p => p.productId);
              this.products = allProducts.filter(prod => allowedIds.includes(prod.id));
              this.filterProducts = [...this.products];

              // Reiniciar input producto
              this.inputs.product.value = '';
              this.inputs.product.class = 'fa-list';
              this.inputs.product.verified = false;
            },
            error: (err: HttpErrorResponse) => {
              this.toastrService.error('Error al cargar productos del proveedor');
            }
          });
        } else {
          this.products = [];
          this.filterProducts = [];
          this.inputs.product.value = '';
          this.toastrService.info('El proveedor no tiene productos CP asociados');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
        this.productsCpVendor = [];
        this.filterProducts = [];
      }
    });
  }



  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    this.currentProduct = product;
    this.getParamSpProviderProduct();
  }

  getParamSpProviderProduct() {
    if (!this.currentProduct || !this.currentProvider) {
      return;
    }
    console.log("Paso");

    this.listParams = [];
    this.getProductParameter();
  }

  writeParameter(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.parameter.class = "typing";
    this.timeout = setTimeout(() => {
      this.getParameters(inputValue);
    }, 500);
  }

  checkParameter(parameter: CoaParameter) {
    this.inputs.parameter.class = "fa-circle-check";
    this.inputs.parameter.verified = true;
    this.inputs.parameter.data = parameter;
    this.inputs.parameter.value = parameter.parameter;
    this.listParams.push({ parameter: parameter, value: null, comment: null });
  }

  removeParam(index: number) {
    this.listParams.splice(index, 1); // elimina 1 elemento en la posición index
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(false);
  }

  closedCreateCoa() {
    this.closed.emit(false);
    this.showModal = false;
  }

  get verifyParameters() {
    let result = false;

    for (let i = 0; i < this.listParams.length; i++) {
      if (this.listParams[i].value==null) {
        result = true;
      }
    }

    return result
  }
}
